import React, {useCallback, useState, useContext} from "react";
import {wizardFormHasSubOption, wizardFormY} from "../../../../../util/Constants";
import {WizardFormSubSelect} from "./WizardFormSubSelect";
import {WizardFormInput} from "./WizardFormInput";
import {WizardContext} from "../Wizard";
import {
    CHANGE_OPTION_DATA,
    RESET_SUB_OPTION_DATA,
    SET_MIN_AND_MAX_PRICE
} from "../../WizardConstants";
import {WizardFormTitle} from "../wizardForm/wizardFormTitle";

const selectOption = (data, type, selectedIdx) => {
    return data.optionList.map((wizardOptionData, i) => {
        if (type === "option") {
            return (<option value={wizardOptionData.idx} key={"option-" + i}>{wizardOptionData.name} {wizardOptionData.soldout_yn === 'Y' ? '[품절]' : ''}</option>)
        } else {
            if (wizardOptionData[wizardFormHasSubOption] === wizardFormY) {
                return (<WizardFormSubSelect data={wizardOptionData} key={"suboption-" + i} selectedIdx={selectedIdx}/>)
            } else {
                return false
            }
        }
    })
}

const select = "select";
const directSelect = "-";

const initialObj = {
    optionName: '',
    optionValue: 0,
    price_min: 0,
    price_max: 0,
    has_subOption: '',
    direct: false,
    selected: 0,
}

export function WizardFormSelect({ data }) {
    const { dispatch } = useContext(WizardContext);
    const [selectedIdx, setSelectedIdx] = useState(0);
    const [directInput, setDirectInput] = useState(false);
    const [optionDescription, setOptionDescription] = useState('');

    const onChange = useCallback((e) => {
        let optionObj = {...initialObj}
        if(e.target.value === select) {
            optionObj = {...initialObj}
            dispatch({
                type: RESET_SUB_OPTION_DATA,
                dataName: e.currentTarget.name,
                optionName: optionObj.optionName,
                optionValue: optionObj.optionValue,
                price_min: optionObj.price_min,
                price_max: optionObj.price_max,

            })
            setOptionDescription('');
        }else if (e.target.value === directSelect) {
            optionObj.direct = true;
            dispatch({
                type: RESET_SUB_OPTION_DATA,
                dataName: e.currentTarget.name,
                optionName: optionObj.optionName,
                optionValue: optionObj.optionValue,
                price_min: optionObj.price_min,
                price_max: optionObj.price_max,

            })
            setOptionDescription('');
        }else {
            const selectedOption = data.optionList.find(item => item.idx === parseInt(e.target.value))
            if (selectedOption.soldout_yn === 'Y') {
                alert('품절된 옵션입니다. 다른 옵션을 선택해주세요.');
                optionObj = {...initialObj}
                dispatch({
                    type: RESET_SUB_OPTION_DATA,
                    dataName: e.currentTarget.name,
                    optionName: optionObj.optionName,
                    optionValue: optionObj.optionValue,
                    price_min: optionObj.price_min,
                    price_max: optionObj.price_max,
                })
                setOptionDescription('');
                e.target.value = select;
                setSelectedIdx(0);
                return
            } 
            optionObj.optionName = selectedOption.name;
            optionObj.optionValue = selectedOption.idx;
            optionObj.price_min = selectedOption.price_min;
            optionObj.price_max = selectedOption.price_max;
            optionObj.has_subOption = selectedOption.has_suboption;
            optionObj.direct = false;
            optionObj.selected = e.target.value;
            setOptionDescription(selectedOption.description);
        }
        dispatch({
            type: CHANGE_OPTION_DATA,
            dataName: e.currentTarget.name,
            optionName: optionObj.optionName,
            optionValue: optionObj.optionValue,
            has_subOption: optionObj.has_subOption,
            price_min: optionObj.price_min,
            price_max: optionObj.price_max,

        })
        dispatch({
            type: SET_MIN_AND_MAX_PRICE,
        })

        setDirectInput(optionObj.direct)
        setSelectedIdx(optionObj.selected)


    }, [dispatch, data]);

    return (

        <div className="form-group">
            <WizardFormTitle musthave={data.musthave} name={data.name} description={data.description}/>
            <select name={data.name}
                    className="form-control form-control-solid form-control-lg"
                    onChange={onChange}>
                <option value={select}>선택</option>
                {selectOption(data, "option")}
                {data.direct_yn === "Y" && <option value={directSelect}>직접입력</option>}
            </select>
            {optionDescription.length > 0 ?
            <span className="btn btn-md bg-white-o-15 mr-4">
              <i className="flaticon2-shopping-cart-1 text-success"></i>
              {optionDescription}
            </span> : ''}

            <label></label>
            {selectOption(data, "subOption", selectedIdx)}
            {(data.direct_yn && directInput) && <WizardFormInput data={data}/>}
        </div>
    )
}